<template>
  <div class="right-chart-wrapper" v-loading="pending">
    <div id="right-chart"></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    },
    pending: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    pending () {
      this.drawChart()
    }
  },
  methods: {
    drawChart () {
      if (this.pending) {
        return
      }
      const myLineChar = this.$echarts.init(document.getElementById('right-chart'))
      myLineChar.setOption({
        color: ['#A43FE7', '#FF8737', '#1D7ADC'],
        title: {
          text: '命中IP风险等级',
          textStyle: {
            color: '#3D3D3D',
            fontSize: 14
          },
          left: 24,
          top: 24
        },
        legend: {
          bottom: '15',
          right: '15',
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 30,
          data: ['风险等级:高', '风险等级:中', '风险等级:低']
        },
        series: [
          {
            center: ['50%', '40%'],
            name: '命中IP风险等级',
            type: 'pie',
            radius: ['25%', '40%'],
            avoidLabelOverlap: true,
            label: {
              show: true,
              formatter: '{b}:  {c}'
            },
            labelLine: {
              show: false
            },
            data: [
              { value: this.data.high, name: '风险等级:高' },
              { value: this.data.mid, name: '风险等级:中' },
              { value: this.data.low, name: '风险等级:低' }
            ]
          }
        ]
      })
      myLineChar.resize()
    }
  },
  mounted () {
    this.drawChart()
    window.addEventListener('resize', this.drawChart)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.drawChart)
    })
  }
}
</script>

<style lang="scss" scoped>
.right-chart-wrapper {
  height: 323px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(17, 39, 98, 0.04);
  border-radius: 4px;
  width: 49%;
  #right-chart {
    width: 100%;
    height: 100%;
  }
}
</style>
